// Epson ePOS-Print: Epson TM printers with ePOS accept print jobs over HTTP(S)
// directly from the browser, no agent needed. The ESC/POS bytes rendered by the
// backend are sent unchanged inside an ePOS-Print <command> element (hex).

export function bytesToHex(bytes) {
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export function buildEposEnvelope(bytes) {
  return (
    '<?xml version="1.0" encoding="utf-8"?>'
    + '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/"><s:Body>'
    + '<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">'
    + `<command>${bytesToHex(bytes)}</command>`
    + '</epos-print></s:Body></s:Envelope>'
  );
}

export function eposServiceUrl(target, pageProtocol = window.location.protocol) {
  const raw = String(target || '').trim().replace(/\/+$/, '');
  if (!raw) throw new Error('IP-Adresse des Epson-Druckers fehlt');
  // An https page may only call https; the printer's certificate must be accepted once in the browser.
  const base = /^https?:\/\//i.test(raw) ? raw : `${pageProtocol === 'https:' ? 'https' : 'http'}://${raw}`;
  return `${base}/cgi-bin/epos/service.cgi?devid=local_printer&timeout=10000`;
}

export function parseEposResponse(xmlText) {
  const success = /<response[^>]*\bsuccess="(true|false)"/i.exec(xmlText || '');
  if (success && success[1].toLowerCase() === 'true') return { ok: true };
  const code = /\bcode="([^"]*)"/i.exec(xmlText || '');
  return { ok: false, code: code ? code[1] : 'UNKNOWN' };
}

export async function printWithEpos(target, bytes) {
  let response;
  try {
    response = await fetch(eposServiceUrl(target), {
      method: 'POST',
      headers: {
        'Content-Type': 'text/xml; charset=utf-8',
        'If-Modified-Since': 'Thu, 01 Jan 1970 00:00:00 GMT',
        SOAPAction: '""',
      },
      body: buildEposEnvelope(bytes),
    });
  } catch {
    throw new Error(
      `Epson-Drucker ${target} nicht erreichbar. Bei HTTPS bitte einmal https://${target} öffnen und das Zertifikat akzeptieren.`,
    );
  }
  const result = parseEposResponse(await response.text());
  if (!response.ok || !result.ok) {
    throw new Error(`Epson-Drucker meldet Fehler ${result.code || response.status}`);
  }
}
